import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DialogDoneButton } from '@/components/DialogDoneButton';

const TITLE_ID = 'info-dialog-title';
const BODY_ID = 'info-dialog-body';

interface InfoDialogProps {
  title: string;
  body: string;
  onClose: () => void;
}

/** A read-only note with a Close button — the sharer's "Shared with you" explanations. */
export function InfoDialog({ title, body, onClose }: InfoDialogProps) {
  return (
    <Dialog
      open
      onClose={onClose}
      aria-labelledby={TITLE_ID}
      aria-describedby={BODY_ID}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id={TITLE_ID}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={BODY_ID}>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogDoneButton onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
}
